export default __webpack_public_path__ + "static/media/madame_front.6ae844c3.jpg";